import axios from "axios";

/**
 * API へ質問を送信
 * @param {string} askText - ユーザーの質問
 * @returns {Promise<{responseText: string, documents: Array}>} - AI の応答と関連ドキュメント
 */
export async function sendAsk(config, askText, current_chatid) {
 if (!askText.trim()) return { responseText: "質問が空です。", documents: [] };
/*
 var params = {
     search_query: format(config.SearchQ,askText),
     type: 6,
     owner_id: config.OwnerID,
     neural_k: config.NaturalK,
     rerank: config.Rerank,
     rerank_top_n:config.RerankTopN,
     rerank_min_score:config.RerankMinScore,
     result_page_size:config.ResultPageSize,
     llm_documents_size:config.llmDocumentsSize
    }*/

  var params = {
     search_query: format(config.SearchQ,askText),
     type: 8,
     owner_id: config.OwnerID,
     neural_k: config.NaturalK,
     rerank: config.Rerank,
     rerank_top_n:config.RerankTopN,
     rerank_min_score:config.RerankMinScore,
     result_page_size:config.ResultPageSize,
     llm_documents_size:config.llmDocumentsSize
    }

 if(config.LLMQ.length > 0){
    params.llm_query = format(config.LLMQ,askText);
 }

 if(current_chatid.length > 0){
    params.chat_id = current_chatid;
 }

 try {
  const response = await fetch(
   "https://mbauq77rwjgaqeu2xpk7rkv3na0gvaem.lambda-url.ap-northeast-1.on.aws/", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(params),
   }
  );

  const data = await response.json();
  return {
   responseText: data.response?.text?.replaceAll("\n", "<br/>") || "応答なし",
   documents: data.response?.documents || [],
   reqid: data.requestId,
   chatid: data.response?.chat_id || ""
  };
 } catch (error) {
  console.error("APIエラー:", error);
  return { responseText: "エラーが発生しました。", documents: [], reqid: "" };
 }
}

export async function sendNewAsk(config, askText, category, current_chatid) {
 if (!askText.trim()) return { responseText: "質問が空です。", documents: [] };

  var params = {
     prompt: format(config.SearchQ,askText),
     customerId: config.USER_ID // 顧客IDを追加
  }

  if(category.length > 0){
    params.category = category;
  }

  if(current_chatid.length > 0){
    params.sessionId = current_chatid;
  }

 try {
  const response = await fetch(
   process.env.REACT_APP_NEW_ASK_API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(params),
   }
  );

  if (!response.ok) {
    const errorText = await response.text();
    console.error("APIエラー:", `Status: ${response.status}`, errorText);
    return { responseText: `サーバーエラーが発生しました (Status: ${response.status})`, documents: [], reqid: "", chatid: current_chatid };
  }

  const data = await response.json();
  console.log(data);
  return {
   responseText: data.response?.replaceAll("\n", "<br/>") || "応答なし",
   documents: data?.sources || [],
   reqid: data.requestId,
   chatid: data?.sessionId || current_chatid
  };
 } catch (error) {
  console.error("APIエラー:", error);
  return { responseText: "エラーが発生しました。", documents: [], reqid: "", chatid: current_chatid };
 }
}

/**
 * フィードバックを送信
 * @returns {Promise<string>} - フィードバック送信結果
 */
export async function sendFeedback(reqID, rating, comment = "") {
 try {
  const response = await fetch(
   process.env.REACT_APP_FEEDBACK_API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
     request_id: reqID,
     rating: rating,
     feed_back: comment,
    }),
   }
  );

  const data = await response.json();
  return data.response?.text || "フィードバックが送信されました。";
 } catch (error) {
  console.error("フィードバック送信エラー:", error);
  return "フィードバック送信中にエラーが発生しました。";
 }
}

export async function getOneTimeToken(config, cid, page) {
 try {

  var url = config.API_URL + "/BookEnd/onetime/token/v1/create";
  var obj_param = {
   APIKey: config.API_KEY,
   ContentsID: cid,
   TokenType: 1,
   NumOfAccess: 1,
   WebSiteHost: config.ViewerHost,
   AutoCreate: "true",
   ViewerSetting: JSON.stringify({ "pn": page }),
  };

  const url_params = new URLSearchParams(obj_param);

  const { data } = await axios.post(url, url_params);

  if (!data?.TokenInfo?.tokenID) {
   throw new Error("トークンが取得できませんでした。");
  }

  return { token: data.TokenInfo.tokenID };

 } catch (error) {
  console.error("トークン取得エラー:", error);
  return {
   token: ""
  };
 }
}

const format = (str, ...args) => {
  for (const [i, arg] of args.entries()) {
    const regExp = new RegExp(`\\{${i}\\}`, 'g')
    str = str.replace(regExp, arg)
  }
  return str
}